<!-- Header da Pagina -->
<div class="page-header">
  <div class="header-icon">
    <i class="pi pi-cog"></i>
  </div>
  <div class="header-content">
    <h1 class="header-title">{{'configuracao-mine-shop.texts.configuracao_mine_shop' | translate}}</h1>
    <p class="header-subtitle">{{'configuracao-mine-shop.texts.desc_aparencia' | translate}}</p>
  </div>
</div>

<!-- Card de status master: habilitar/desabilitar Mini Shopping -->
<div class="minishop-status-card">
  <div class="minishop-status-card__info">
    <div class="minishop-status-card__icon">
      <i class="pi pi-power-off"></i>
    </div>
    <div class="minishop-status-card__text">
      <div class="minishop-status-card__title">
        {{ 'configuracao-mine-shop.texts.habilitar_minishop' | translate }}
      </div>
      <div class="minishop-status-card__subtitle">
        {{ 'configuracao-mine-shop.texts.habilitar_minishop_desc' | translate }}
      </div>
    </div>
  </div>
  <div class="minishop-status-card__control">
    <p-progressSpinner
      *ngIf="loadingHabilitar"
      styleClass="minishop-status-card__spinner"
      strokeWidth="4"
      animationDuration=".6s">
    </p-progressSpinner>
    <p-inputSwitch
      #chaveHabilitar
      [ngModel]="habilitarMiniShopping"
      (onChange)="onToggleHabilitarMiniShopping($event.checked)"
      [disabled]="loadingHabilitar"
      [ariaLabel]="'configuracao-mine-shop.texts.habilitar_minishop' | translate">
    </p-inputSwitch>
  </div>
</div>

<!-- Card de notificacao sonora (preferencia local) -->
<div class="minishop-status-card">
  <div class="minishop-status-card__info">
    <div class="minishop-status-card__icon">
      <i class="pi pi-volume-up"></i>
    </div>
    <div class="minishop-status-card__text">
      <div class="minishop-status-card__title">
        {{ 'configuracao-mine-shop.texts.notificacao_sonora' | translate }}
      </div>
      <div class="minishop-status-card__subtitle">
        {{ 'configuracao-mine-shop.texts.notificacao_sonora_desc' | translate }}
      </div>
    </div>
  </div>
  <div class="minishop-status-card__control">
    <p-inputSwitch
      [ngModel]="somNotificacaoHabilitado"
      (onChange)="onToggleSomNotificacao($event.checked)"
      [ariaLabel]="'configuracao-mine-shop.texts.notificacao_sonora' | translate">
    </p-inputSwitch>
  </div>
</div>

<div class="cards-container">
  <!-- Card Horarios de Funcionamento -->
  <div class="form-card">
    <div class="card-header">
      <div class="card-header-icon">
        <i class="pi pi-clock"></i>
      </div>
      <span class="card-header-title">{{'configuracao-mine-shop.texts.horarios_funcionamento' | translate}}</span>
      <div class="card-header-action">
        <p-button [label]="('configuracao-mine-shop.texts.btn_cadastrar_horario' | translate) + ' (F2)'"
          icon="pi pi-calendar-plus" styleClass="p-button-raised border-round-lg"
          (click)="openDialogHorarios()"></p-button>
      </div>
    </div>
    <div class="card-content">
      <div class="horarios-grid">
        <div *ngFor="let dia of diasSemanaOptions" class="horario-dia-card" (click)="openDialogHorarios()">
          <div class="horario-dia-header">
            <span class="horario-dia-nome">{{ dia.label }}</span>
            <p-tag *ngIf="horariosPorDia[mapDiaToEnum(dia.value)]?.length" severity="success"
              [value]="'configuracao-mine-shop.texts.aberto' | translate" [rounded]="true"
              styleClass="px-3 text-xs font-bold"></p-tag>
            <p-tag *ngIf="!horariosPorDia[mapDiaToEnum(dia.value)]?.length" severity="danger"
              [value]="'configuracao-mine-shop.texts.fechado' | translate" [rounded]="true"
              styleClass="px-3 text-xs font-bold"></p-tag>
          </div>
          <div class="horario-dia-body">
            <ng-container *ngIf="horariosPorDia[mapDiaToEnum(dia.value)]?.length; else fechadoTemplate">
              <div *ngFor="let h of horariosPorDia[mapDiaToEnum(dia.value)]" class="horario-badge">
                <i class="pi pi-circle-fill horario-badge-dot"></i>
                {{ formatHora(h.horaInicial) }} - {{ formatHora(h.horaFinal) }}
              </div>
            </ng-container>
            <ng-template #fechadoTemplate>
              <span class="horario-sem-expediente">{{'configuracao-mine-shop.texts.sem_expediente' | translate}}</span>
            </ng-template>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Card Aparencia -->
  <div class="form-card">
    <div class="card-header">
      <div class="card-header-icon contact-icon">
        <i class="pi pi-palette"></i>
      </div>
      <span class="card-header-title">{{'configuracao-mine-shop.texts.aparencia_minishop' | translate}}</span>
      <div class="card-header-action">
        <p-button [label]="('configuracao-mine-shop.texts.configurar_estilo' | translate) + ' (F3)'" icon="pi pi-pencil"
          styleClass="p-button-raised border-round-lg" (click)="openDialogAparencia()"></p-button>
      </div>
    </div>
    <div class="card-content">
      <div class="aparencia-grid">
        <!-- Coluna Esquerda: Banner + Cores -->
        <div class="aparencia-left">
          <div class="aparencia-section">
            <span class="section-label">{{'configuracao-mine-shop.texts.banner_titulo' | translate}}</span>
            <div class="banner-preview" (click)="openDialogAparencia()">
              <img *ngIf="imagePreviewUrl" [src]="imagePreviewUrl"
                class="banner-image" />
              <div *ngIf="!imagePreviewUrl" class="banner-placeholder">
                <i class="pi pi-image"></i>
                <span>{{'configuracao-mine-shop.texts.sem_banner_definido' | translate}}</span>
              </div>
            </div>
          </div>

          <div class="aparencia-section">
            <span class="section-label">{{'configuracao-mine-shop.texts.paleta_cores_ativa' | translate}}</span>
            <div class="cores-grid">
              <div *ngFor="let cor of [
                {label: 'configuracao-mine-shop.texts.cor_fundo_cabecalho', control: 'minishopCabecalhoCorDeFundo'},
                {label: 'configuracao-mine-shop.texts.cor_fonte_cabecalho', control: 'minishopCabecalhoCorDaFonte'},
                {label: 'configuracao-mine-shop.texts.cor_fundo_grupos', control: 'minishopGruposCorDeFundo'},
                {label: 'configuracao-mine-shop.texts.cor_fonte_grupos', control: 'minishopGruposCorDaFonte'},
                {label: 'configuracao-mine-shop.texts.cor_fundo', control: 'minishopGeralCorDeFundo'},
                {label: 'configuracao-mine-shop.texts.cor_fonte', control: 'minishopGeralCorDaFonte'},
                {label: 'configuracao-mine-shop.texts.cor_fundo_card', control: 'minishopCardCorDeFundo'},
                {label: 'configuracao-mine-shop.texts.cor_fonte_card', control: 'minishopCardCorDaFonte'},
                {label: 'configuracao-mine-shop.texts.tooltip_botoes_fundo', control: 'minishopBotoesCorDeFundo'},
                {label: 'configuracao-mine-shop.texts.tooltip_botoes_texto', control: 'minishopBotoesCorDaFonte'}
              ]" class="cor-item" (click)="openDialogAparencia()" style="cursor: pointer;">
                <div class="cor-circle"
                  [style.backgroundColor]="formAparencia.get(cor.control)?.value || '#eee'">
                </div>
                <label class="cor-label" style="cursor: pointer;">{{cor.label | translate}}</label>
                <code class="cor-hex">{{ formAparencia.get(cor.control)?.value || '#---' }}</code>
              </div>
            </div>
          </div>
        </div>

        <!-- Coluna Direita: Canais de Contato -->
        <div class="aparencia-right">
          <span class="section-label">{{'configuracao-mine-shop.texts.canais_contato' | translate}}</span>
          <div class="canais-list">
            <div class="canal-item canal-url">
              <i class="pi pi-link canal-icon"></i>
              <div class="canal-info">
                <small class="canal-label">{{'configuracao-mine-shop.texts.url_loja' | translate}}</small>
                <a *ngIf="formAparencia.get('urlDoMiniShopping')?.value && habilitarMiniShopping; else semLink"
                   class="canal-value canal-link"
                   [href]="'/menu/' + formAparencia.get('urlDoMiniShopping')?.value"
                   target="_blank"
                   rel="noopener noreferrer">
                  {{ '/menu/' + formAparencia.get('urlDoMiniShopping')?.value }}
                </a>
                <!-- Sem link clicavel: MiniShop desabilitado nao abre a loja publica -->
                <ng-template #semLink>
                  <span *ngIf="formAparencia.get('urlDoMiniShopping')?.value; else semUrl"
                        class="canal-value"
                        [attr.title]="'cardapio_minishop.comum.minishop_desabilitado' | translate">
                    {{ '/menu/' + formAparencia.get('urlDoMiniShopping')?.value }}
                  </span>
                </ng-template>
                <ng-template #semUrl>
                  <span class="canal-value">{{ 'configuracao-mine-shop.texts.nao_definido' | translate }}</span>
                </ng-template>
              </div>
            </div>

            <div class="canal-item canal-whatsapp">
              <i class="pi pi-whatsapp canal-icon"></i>
              <div class="canal-info">
                <small class="canal-label">{{'configuracao-mine-shop.texts.whatsapp' | translate}}</small>
                <span class="canal-value">{{
                  formAparencia.get('telefone')?.value ||
                  ('configuracao-mine-shop.texts.nao_informado' | translate) }}</span>
              </div>
            </div>

            <div class="canal-item canal-instagram">
              <i class="pi pi-instagram canal-icon"></i>
              <div class="canal-info">
                <small class="canal-label">{{'configuracao-mine-shop.texts.instagram' | translate}}</small>
                <span class="canal-value">{{
                  formAparencia.get('perfilInstagram')?.value ||
                  ('configuracao-mine-shop.texts.nao_informado' | translate) }}</span>
              </div>
            </div>

            <div class="canal-item canal-facebook">
              <i class="pi pi-facebook canal-icon"></i>
              <div class="canal-info">
                <small class="canal-label">{{'configuracao-mine-shop.texts.facebook' | translate}}</small>
                <span class="canal-value">{{
                  formAparencia.get('perfilFacebook')?.value ||
                  ('configuracao-mine-shop.texts.nao_vinculado' | translate) }}</span>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Card Preco e Cobertura de Envio -->
  <div class="form-card">
    <div class="card-header">
      <div class="card-header-icon address-icon">
        <i class="pi pi-map"></i>
      </div>
      <span class="card-header-title">{{'configuracao-mine-shop.texts.preco_cobertura_envio' | translate}}</span>
      <div class="card-header-action">
        <p-button [label]="('configuracao-mine-shop.texts.ajustar_entrega' | translate) + ' (F4)'" icon="pi pi-cog"
          styleClass="p-button-raised border-round-lg" (click)="openDialogPrecoECobertura()"></p-button>
      </div>
    </div>
    <div class="card-content">
      <div class="envio-resumo">
        <div class="envio-endereco">
          <div class="envio-icon-container">
            <i class="pi pi-send"></i>
          </div>
          <div class="envio-info">
            <span class="envio-label">{{'configuracao-mine-shop.texts.endereco_atual' | translate}}</span>
            <span class="envio-value">
              {{ configuracaoEmpresaAtual?.endereco ||
              ('configuracao-mine-shop.texts.ponto_origem_nao_definido' | translate) }}</span>
          </div>
        </div>

        <div class="envio-divider"></div>

        <div class="envio-estrategia">
          <span class="envio-label">{{'configuracao-mine-shop.texts.estrategia_cobranca' | translate}}</span>
          <p-tag
            [value]="configuracaoEmpresaAtual?.tipoPrecoCoberturaDeEnvio?.descricao || ('configuracao-mine-shop.texts.nao_definido' | translate | uppercase)"
            severity="info" styleClass="border-round-pill px-4 py-2 font-bold shadow-sm"></p-tag>
        </div>
      </div>
    </div>
  </div>
  <!-- Card do que o pedido de consumo no local exige.
       As mesmas regras valem para a tela interna de Criar Pedido. -->
  <div class="form-card">
    <div class="card-header">
      <div class="card-header-icon">
        <i class="pi pi-table"></i>
      </div>
      <span class="card-header-title">
        {{ 'configuracao-mine-shop.texts.exigencias_pedido' | translate }}
      </span>
      <div class="card-header-action">
        <p-button
          [label]="'common.salvar' | translate"
          icon="pi pi-check"
          styleClass="p-button-raised border-round-lg"
          [loading]="salvandoExigenciasDoPedido"
          (click)="salvarExigenciasDoPedido()">
        </p-button>
      </div>
    </div>
    <div class="card-content">
      <p class="fp-minishop__desc">
        {{ 'configuracao-mine-shop.texts.exigencias_pedido_desc' | translate }}
      </p>

      <div class="fp-minishop__linha">
        <p-inputSwitch [(ngModel)]="exigenciasDoPedido.numeroDaMesa"></p-inputSwitch>
        <div class="fp-minishop__texto">
          <strong>{{ 'configuracao-mine-shop.texts.exigir_mesa' | translate }}</strong>
          <small>{{ 'configuracao-mine-shop.texts.exigir_mesa_desc' | translate }}</small>
        </div>
      </div>

      <div class="fp-minishop__linha">
        <p-inputSwitch [(ngModel)]="exigenciasDoPedido.numeroDaComanda"></p-inputSwitch>
        <div class="fp-minishop__texto">
          <strong>{{ 'configuracao-mine-shop.texts.exigir_comanda' | translate }}</strong>
          <small>{{ 'configuracao-mine-shop.texts.exigir_comanda_desc' | translate }}</small>
        </div>
      </div>
    </div>
  </div>

  <!-- Card de formas de pagamento do minishop.
       As mesmas regras valem para a tela interna de Criar Pedido. -->
  <div class="form-card">
    <div class="card-header">
      <div class="card-header-icon">
        <i class="pi pi-wallet"></i>
      </div>
      <span class="card-header-title">
        {{ 'configuracao-mine-shop.texts.formas_pagamento' | translate }}
      </span>
      <div class="card-header-action">
        <p-button
          [label]="'common.salvar' | translate"
          icon="pi pi-check"
          styleClass="p-button-raised border-round-lg"
          [loading]="salvandoFormasDePagamento"
          (click)="salvarFormasDePagamento()">
        </p-button>
      </div>
    </div>
    <div class="card-content">
      <p class="fp-minishop__desc">
        {{ 'configuracao-mine-shop.texts.formas_pagamento_desc' | translate }}
      </p>

      <div class="fp-minishop__linha">
        <p-inputSwitch [(ngModel)]="formasDePagamento.exibir"></p-inputSwitch>
        <span>{{ 'configuracao-mine-shop.texts.exibir_formas_pagamento' | translate }}</span>
      </div>

      <div class="fp-minishop__opcoes" *ngIf="formasDePagamento.exibir">
        <div class="fp-minishop__linha">
          <p-inputSwitch [(ngModel)]="formasDePagamento.dinheiro"></p-inputSwitch>
          <span>{{ 'configuracao-mine-shop.texts.forma_dinheiro' | translate }}</span>
        </div>

        <div class="fp-minishop__linha">
          <p-inputSwitch [(ngModel)]="formasDePagamento.tarjeta"></p-inputSwitch>
          <span>{{ 'configuracao-mine-shop.texts.forma_tarjeta' | translate }}</span>
        </div>

        <div class="fp-minishop__linha">
          <p-inputSwitch [(ngModel)]="formasDePagamento.qrCode"></p-inputSwitch>
          <span>{{ 'configuracao-mine-shop.texts.forma_qrcode' | translate }}</span>
        </div>

        <!-- Cada forma cobra por uma API diferente da Bancard: o QR pelo QR Vendas, o cartao
             pelo tpago (link de pagamento). Ter uma configurada nao habilita a outra. -->
        <small
          class="fp-minishop__aviso"
          *ngIf="formasDePagamento.qrCode && !bancardConfigurado">
          {{ 'configuracao-mine-shop.texts.formas_pagamento_sem_bancard' | translate }}
        </small>
        <small
          class="fp-minishop__aviso"
          *ngIf="formasDePagamento.tarjeta && !tpagoConfigurado">
          {{ 'configuracao-mine-shop.texts.formas_pagamento_sem_tpago' | translate }}
        </small>

        <!-- A conta onde esse dinheiro entra e escolhida em Configuracoes > Dados de
             recebimento, junto das chaves da Bancard: la se diz com que cadastro se cobra e para
             onde o dinheiro vai. Aqui so se escolhe o que o cliente ve no checkout. -->
        <small
          class="fp-minishop__ajuda"
          *ngIf="formasDePagamento.qrCode || formasDePagamento.tarjeta">
          {{ 'configuracao-mine-shop.texts.conta_recebimento_outra_tela' | translate }}
        </small>

        <div class="fp-minishop__linha">
          <p-inputSwitch [(ngModel)]="formasDePagamento.transferencia"></p-inputSwitch>
          <span>{{ 'configuracao-mine-shop.texts.forma_transferencia' | translate }}</span>
        </div>

        <small class="fp-minishop__ajuda" *ngIf="formasDePagamento.transferencia">
          {{ 'configuracao-mine-shop.texts.forma_transferencia_ajuda' | translate }}
        </small>
      </div>
    </div>
  </div>

</div>


<p-sidebar [(visible)]="mostrarCadastrarHorarios" position="right" [style]="{ width: '42rem' }" [blockScroll]="true"
    styleClass="shadow-lg">
    <ng-template pTemplate="header">
        <div class="sidebar-wave-header sidebar-wave-header--info">
            <div class="sidebar-wave-header-content">
                <div class="sidebar-wave-icon-container">
                    <i class="pi pi-clock" aria-hidden="true"></i>
                </div>
                <div class="sidebar-wave-header-text">
                    <h2>{{'configuracao-mine-shop.texts.horarios_funcionamento' | translate}}</h2>
                    <p>{{'configuracao-mine-shop.texts.defina_periodos' | translate}}</p>
                </div>
                <!-- Indicador de autosave -->
                <div class="autosave-indicator" *ngIf="estadoSalvamentoHorarios">
                    <span *ngIf="estadoSalvamentoHorarios === 'salvando'" class="autosave-salvando">
                        <i class="pi pi-spin pi-spinner"></i>
                        {{'configuracao-mine-shop.texts.autosave_salvando' | translate}}
                    </span>
                    <span *ngIf="estadoSalvamentoHorarios === 'guardado'" class="autosave-guardado">
                        <i class="pi pi-check-circle"></i>
                        {{'configuracao-mine-shop.texts.autosave_guardado' | translate}}
                    </span>
                    <span *ngIf="estadoSalvamentoHorarios === 'erro'" class="autosave-erro"
                          [title]="detalheErroAutosaveHorarios || ('configuracao-mine-shop.texts.autosave_erro' | translate)">
                        <i class="pi pi-exclamation-circle"></i>
                        {{'configuracao-mine-shop.texts.autosave_erro' | translate}}
                        <small *ngIf="detalheErroAutosaveHorarios" class="autosave-erro-detalhe"> — {{ detalheErroAutosaveHorarios }}</small>
                    </span>
                </div>
            </div>
            <div class="sidebar-wave-decorative-circle circle-1" aria-hidden="true"></div>
            <div class="sidebar-wave-decorative-circle circle-2" aria-hidden="true"></div>
            <svg class="sidebar-wave-svg" viewBox="0 0 1200 40" preserveAspectRatio="none" aria-hidden="true">
                <path d="M0,20 C150,40 350,0 500,20 C650,40 850,0 1000,20 C1100,32 1150,20 1200,20 L1200,40 L0,40 Z" fill="white"/>
            </svg>
        </div>
    </ng-template>

    <form [formGroup]="formHorario" class="p-fluid pr-2">
        <div formGroupName="dias" class="pt-3 flex flex-column gap-3">

            <div *ngFor="let dia of diasSemanaOptions; let i = index" [formGroupName]="dia.value"
                class="surface-card border-round-xl border-1 surface-border shadow-sm p-3 transition-all transition-duration-200 hover:shadow-md"
                [ngClass]="{'bg-gray-50': !formHorario.get('dias.' + dia.value)?.value}">

                <div class="flex align-items-center justify-content-between">
                    <div class="flex align-items-center gap-3">
                        <p-inputSwitch formControlName="ativo"
                            (onChange)="onToggleDiaAtivo(dia.value, $event.checked)"></p-inputSwitch>
                        <span class="font-bold text-lg text-900 w-10rem">{{ dia.label }}</span>
                    </div>

                    <p-tag [severity]="formHorario.get('dias.' + dia.value + '.ativo')?.value ? 'success' : 'danger'"
                        [value]="(formHorario.get('dias.' + dia.value + '.ativo')?.value ? 'configuracao-mine-shop.texts.aberto' : 'configuracao-mine-shop.texts.fechado') | translate"
                        styleClass="border-round-pill px-3 font-bold uppercase text-xs">
                    </p-tag>
                </div>

                <div *ngIf="formHorario.get('dias.' + dia.value + '.ativo')?.value" formArrayName="horarios"
                    class="mt-3 pt-3 border-top-1 surface-border flex flex-column gap-3 animation-duration-200 fadein">

                    <div *ngFor="let horario of getHorarios(dia.value).controls; let j = index" [formGroupName]="j"
                        class="flex align-items-center gap-2 md:gap-4 bg-white border-round-lg p-2 border-1 surface-100 border-transparent hover:border-primary transition-colors">

                        <i class="pi pi-calendar-times text-400 hidden md:block ml-2"></i>

                        <div class="flex-1 flex flex-column gap-1">
                            <div class="flex align-items-center gap-2">
                                <span
                                    class="text-xs font-bold text-500 uppercase md:hidden">{{'configuracao-mine-shop.texts.inicio'
                                    | translate}}</span>
                                <p-inputMask formControlName="abertura"
                                    mask="99:99"
                                    placeholder="HH:MM"
                                    slotChar="HH:MM"
                                    [ngClass]="{'ng-invalid ng-dirty': temHoraIncompleta(dia.value, j, 'abertura')}"
                                    styleClass="w-full"></p-inputMask>
                            </div>
                            <small *ngIf="temHoraIncompleta(dia.value, j, 'abertura')"
                                class="p-error">
                                {{'configuracao-mine-shop.texts.hora_invalida' | translate}}
                            </small>
                        </div>

                        <span class="text-400 font-medium lowercase">{{'configuracao-mine-shop.texts.ate' |
                            translate}}</span>

                        <div class="flex-1 flex flex-column gap-1">
                            <div class="flex align-items-center gap-2">
                                <span
                                    class="text-xs font-bold text-500 uppercase md:hidden">{{'configuracao-mine-shop.texts.fim'
                                    | translate}}</span>
                                <p-inputMask formControlName="fechamento"
                                    mask="99:99"
                                    placeholder="HH:MM"
                                    slotChar="HH:MM"
                                    [ngClass]="{'ng-invalid ng-dirty': temHoraIncompleta(dia.value, j, 'fechamento')}"
                                    styleClass="w-full"></p-inputMask>
                            </div>
                            <small *ngIf="temHoraIncompleta(dia.value, j, 'fechamento')"
                                class="p-error">
                                {{'configuracao-mine-shop.texts.hora_invalida' | translate}}
                            </small>
                        </div>

                        <div class="flex align-items-center justify-content-center">
                            <button pButton type="button" icon="pi pi-trash"
                                class="p-button-danger p-button-text p-button-rounded"
                                *ngIf="getHorarios(dia.value).length > 1" (click)="removerHorario(dia.value, j)"
                                [pTooltip]="'configuracao-mine-shop.texts.remover_periodo' | translate">
                            </button>
                            <div style="width: 3rem" *ngIf="getHorarios(dia.value).length === 1"></div>
                        </div>
                    </div>

                    <div class="flex justify-content-start mt-1">
                        <p-button [label]="'configuracao-mine-shop.texts.adicionar_outro_periodo' | translate"
                            icon="pi pi-plus-circle" [text]="true" size="small" (click)="adicionarHorario(dia.value)"
                            styleClass="py-2 font-semibold"></p-button>
                    </div>
                </div>
            </div>
        </div>

        <div class="flex justify-content-start mt-4">
            <p-button [label]="'configuracao-mine-shop.texts.restaurar_horarios_padrao' | translate"
                icon="pi pi-refresh" [text]="true" severity="secondary" size="small"
                (click)="abrirConfirmarResetHorarios()"
                styleClass="font-semibold"></p-button>
        </div>

        <div class="flex justify-content-end mt-6 pt-4 border-top-1 surface-border">
            <p-button [label]="('configuracao-mine-shop.texts.fechar' | translate) + ' (Esc)'" (click)="closeDialog()"
                severity="secondary" styleClass="p-button-text font-bold"></p-button>
        </div>
    </form>
</p-sidebar>

<p-sidebar [(visible)]="mostrarConfigurarAparencia" position="right"
    [style]="{ width: 'min(64rem, 95vw)' }" [blockScroll]="true"
    styleClass="p-sidebar-md shadow-lg aparencia-sidebar" (onHide)="closeAparenciaDialog()">
    <ng-template pTemplate="header">
        <div class="sidebar-wave-header sidebar-wave-header--info">
            <div class="sidebar-wave-header-content">
                <div class="sidebar-wave-icon-container">
                    <i class="pi pi-palette" aria-hidden="true"></i>
                </div>
                <div class="sidebar-wave-header-text">
                    <h2>{{'configuracao-mine-shop.texts.configurar_aparencia' | translate}}</h2>
                    <p>{{'configuracao-mine-shop.texts.personalize_identidade' | translate}}</p>
                </div>
                <!-- Indicador de autosave -->
                <div class="autosave-indicator" *ngIf="estadoSalvamentoAparencia">
                    <span *ngIf="estadoSalvamentoAparencia === 'salvando'" class="autosave-salvando">
                        <i class="pi pi-spin pi-spinner"></i>
                        {{'configuracao-mine-shop.texts.autosave_salvando' | translate}}
                    </span>
                    <span *ngIf="estadoSalvamentoAparencia === 'guardado'" class="autosave-guardado">
                        <i class="pi pi-check-circle"></i>
                        {{'configuracao-mine-shop.texts.autosave_guardado' | translate}}
                    </span>
                    <span *ngIf="estadoSalvamentoAparencia === 'erro'" class="autosave-erro">
                        <i class="pi pi-exclamation-circle"></i>
                        {{'configuracao-mine-shop.texts.autosave_erro' | translate}}
                    </span>
                </div>
            </div>
            <div class="sidebar-wave-decorative-circle circle-1" aria-hidden="true"></div>
            <div class="sidebar-wave-decorative-circle circle-2" aria-hidden="true"></div>
            <svg class="sidebar-wave-svg" viewBox="0 0 1200 40" preserveAspectRatio="none" aria-hidden="true">
                <path d="M0,20 C150,40 350,0 500,20 C650,40 850,0 1000,20 C1100,32 1150,20 1200,20 L1200,40 L0,40 Z" fill="white"/>
            </svg>
        </div>
    </ng-template>

    <form [formGroup]="formAparencia" class="p-fluid pr-2">

        <div class="aparencia-layout mb-4">

        <!-- ============================================================ -->
        <!-- Preview em tempo real das cores do Mini Shop -->
        <!-- Fica sticky a esquerda para o usuario acompanhar as mudancas -->
        <!-- ============================================================ -->
        <div class="aparencia-preview-col">
            <div class="surface-card p-4 border-round-xl border-1 surface-border shadow-sm aparencia-preview-card">
                <div class="flex align-items-center justify-content-between mb-3">
                    <div class="flex align-items-center gap-2">
                        <i class="pi pi-eye text-primary"></i>
                        <span class="text-900 font-bold uppercase text-xs mt-1">
                            {{ 'configuracao-mine-shop.texts.preview_titulo' | translate }}
                        </span>
                    </div>
                    <span class="text-500 text-xs font-medium">
                        {{ 'configuracao-mine-shop.texts.preview_legenda' | translate }}
                    </span>
                </div>

                <div class="aparencia-preview"
                    [style.backgroundColor]="formAparencia.get('minishopGeralCorDeFundo')?.value || '#FFFFFF'"
                    [style.color]="formAparencia.get('minishopGeralCorDaFonte')?.value || '#474747'"
                    role="img"
                    [attr.aria-label]="'configuracao-mine-shop.texts.preview_titulo' | translate">

                    <!-- Cabecalho (faixa do topo) -->
                    <div class="aparencia-preview__cabecalho"
                        [style.backgroundColor]="formAparencia.get('minishopCabecalhoCorDeFundo')?.value || '#0582c5'"
                        [style.color]="formAparencia.get('minishopCabecalhoCorDaFonte')?.value || '#FFFFFF'">
                        <i class="pi pi-shop aparencia-preview__cabecalho-logo" aria-hidden="true"></i>
                        <span class="aparencia-preview__cabecalho-nome">
                            {{ 'configuracao-mine-shop.texts.preview_banner_titulo' | translate }}
                        </span>
                        <i class="pi pi-search aparencia-preview__cabecalho-busca" aria-hidden="true"></i>
                    </div>

                    <!-- Dropdown de categorias aberto (cores de grupos) -->
                    <div class="aparencia-preview__dropdown"
                        [style.backgroundColor]="formAparencia.get('minishopGruposCorDeFundo')?.value || '#165c7d'"
                        [style.color]="formAparencia.get('minishopGruposCorDaFonte')?.value || '#FFFFFF'">
                        <span class="aparencia-preview__dropdown-item aparencia-preview__dropdown-item--ativo">
                            {{ 'configuracao-mine-shop.texts.preview_categoria_a' | translate }}
                        </span>
                        <span class="aparencia-preview__dropdown-item">
                            {{ 'configuracao-mine-shop.texts.preview_categoria_b' | translate }}
                        </span>
                        <span class="aparencia-preview__dropdown-item">
                            {{ 'configuracao-mine-shop.texts.preview_categoria_c' | translate }}
                        </span>
                    </div>

                    <!-- Texto sobre o fundo: demonstra a Cor de fonte (geral) -->
                    <p class="aparencia-preview__texto"
                        [style.color]="formAparencia.get('minishopGeralCorDaFonte')?.value || '#474747'">
                        {{ 'configuracao-mine-shop.texts.preview_fundo_texto' | translate }}
                    </p>

                    <!-- Card de produto -->
                    <div class="aparencia-preview__card"
                        [style.backgroundColor]="formAparencia.get('minishopCardCorDeFundo')?.value || '#165c7d'"
                        [style.color]="formAparencia.get('minishopCardCorDaFonte')?.value || '#FFFFFF'">
                        <div class="aparencia-preview__card-img">
                            <i class="pi pi-image" aria-hidden="true"></i>
                        </div>
                        <div class="aparencia-preview__card-info">
                            <span class="aparencia-preview__card-nome">
                                {{ 'configuracao-mine-shop.texts.preview_card_nome' | translate }}
                            </span>
                            <span class="aparencia-preview__card-preco">Gs. 25.000</span>
                        </div>
                    </div>

                    <!-- Botao de acao exemplo -->
                    <button type="button"
                        class="aparencia-preview__botao"
                        tabindex="-1"
                        [style.backgroundColor]="formAparencia.get('minishopBotoesCorDeFundo')?.value || '#0582c5'"
                        [style.color]="formAparencia.get('minishopBotoesCorDaFonte')?.value || '#FFFFFF'">
                        <i class="pi pi-shopping-cart" aria-hidden="true"></i>
                        {{ 'configuracao-mine-shop.texts.preview_botao' | translate }}
                    </button>
                </div>
            </div>
        </div>

        <!-- Coluna direita: seletores de cores -->
        <div class="aparencia-cores-col">
        <div class="surface-card p-4 border-round-xl border-1 surface-border mb-4 shadow-sm">
            <div class="flex align-items-center gap-2 mb-4">
                <i class="pi pi-sliders-h text-primary"></i>
                <span class="text-900 font-bold uppercase text-xs mt-1">{{'configuracao-mine-shop.texts.cores_tema' |
                    translate}}</span>
            </div>

            <!-- <div class="grid mt-2">
                <div class="col-12 md:col-6 mb-3" *ngFor="let colorField of [
                    {label: 'configuracao-mine-shop.texts.cor_fundo_cabecalho', control: 'minishopCabecalhoCorDeFundo'},
                    {label: 'configuracao-mine-shop.texts.cor_fonte_cabecalho', control: 'minishopCabecalhoCorDaFonte'},
                    {label: 'configuracao-mine-shop.texts.cor_fundo_grupos', control: 'minishopGruposCorDeFundo'},
                    {label: 'configuracao-mine-shop.texts.cor_fonte_grupos', control: 'minishopGruposCorDaFonte'},
                    {label: 'configuracao-mine-shop.texts.cor_fundo', control: 'minishopGeralCorDeFundo'},
                    {label: 'configuracao-mine-shop.texts.cor_fonte', control: 'minishopGeralCorDaFonte'},
                    {label: 'configuracao-mine-shop.texts.cor_fundo_card', control: 'minishopCardCorDeFundo'},
                    {label: 'configuracao-mine-shop.texts.cor_fonte_card', control: 'minishopCardCorDaFonte'},
                    {label: 'configuracao-mine-shop.texts.tooltip_botoes_fundo', control: 'minishopBotoesCorDeFundo'},
                    {label: 'configuracao-mine-shop.texts.tooltip_botoes_texto', control: 'minishopBotoesCorDaFonte'}
                ]">
                    <label class="block mb-2 text-sm font-semibold text-700">{{colorField.label | translate}}</label>
                    <div
                        class="flex align-items-center gap-3 border-1 surface-border border-round-lg p-2 bg-white hover:border-primary transition-colors transition-duration-200">
                        <div class="relative flex align-items-center">
                            <input type="color" [formControlName]="colorField.control" class="cursor-pointer"
                                style="border:none; width:38px; height:38px; border-radius: 8px; padding:0; background:none;" />
                        </div>
                        <span class="text-700 text-sm font-mono font-bold">{{
                            formAparencia.get(colorField.control)?.value }}</span>
                    </div>
                </div>
            </div> -->
            <div class="grid mt-2">
                <div class="col-12 md:col-6 mb-3" *ngFor="let colorField of [
                    {label: 'configuracao-mine-shop.texts.cor_fundo_cabecalho', control: 'minishopCabecalhoCorDeFundo'},
                    {label: 'configuracao-mine-shop.texts.cor_fonte_cabecalho', control: 'minishopCabecalhoCorDaFonte'},
                    {label: 'configuracao-mine-shop.texts.cor_fundo_grupos', control: 'minishopGruposCorDeFundo'},
                    {label: 'configuracao-mine-shop.texts.cor_fonte_grupos', control: 'minishopGruposCorDaFonte'},
                    {label: 'configuracao-mine-shop.texts.cor_fundo', control: 'minishopGeralCorDeFundo'},
                    {label: 'configuracao-mine-shop.texts.cor_fonte', control: 'minishopGeralCorDaFonte'},
                    {label: 'configuracao-mine-shop.texts.cor_fundo_card', control: 'minishopCardCorDeFundo'},
                    {label: 'configuracao-mine-shop.texts.cor_fonte_card', control: 'minishopCardCorDaFonte'},
                    {label: 'configuracao-mine-shop.texts.tooltip_botoes_fundo', control: 'minishopBotoesCorDeFundo'},
                    {label: 'configuracao-mine-shop.texts.tooltip_botoes_texto', control: 'minishopBotoesCorDaFonte'}
                ]">
                    <label class="block mb-2 text-sm font-semibold text-700">{{colorField.label | translate}}</label>
                    <div
                        class="flex align-items-center gap-3 border-1 surface-border border-round-lg p-2 bg-white hover:border-primary transition-colors transition-duration-200">
                        <div class="relative flex align-items-center">
                            <input type="color" [formControlName]="colorField.control" class="cursor-pointer"
                                style="border:none; width:38px; height:38px; border-radius: 8px; padding:0; background:none;" />
                        </div>

                        <input type="text" [value]="formAparencia.get(colorField.control)?.value"
                            (input)="onHexChange($event, colorField.control)"
                            class="border-none outline-none text-700 text-sm font-mono font-bold w-full p-1"
                            placeholder="#000000" maxlength="7" />
                    </div>
                </div>
            </div>

            <div class="flex justify-content-end mt-3">
                <p-button [label]="'configuracao-mine-shop.texts.restaurar_cores_padrao' | translate"
                    icon="pi pi-refresh" [text]="true" severity="secondary" size="small"
                    (click)="abrirConfirmarResetCores()"
                    styleClass="font-semibold"></p-button>
            </div>
        </div>
        </div> <!-- /aparencia-cores-col -->
        </div> <!-- /aparencia-layout -->

        <div class="surface-card p-4 border-round-xl border-1 surface-border mb-4 shadow-sm">
            <div class="flex align-items-center gap-2 mb-4">
                <i class="pi pi-image text-primary"></i>
                <span class="text-900 font-bold uppercase text-xs mt-1">{{'configuracao-mine-shop.texts.banner_titulo' |
                    translate}}</span>
            </div>

            <div class="flex flex-column align-items-center w-full">
                <div *ngIf="imagePreviewUrl"
                    class="relative w-full border-round-xl overflow-hidden shadow-2 surface-100 mb-3 border-1 surface-border"
                    style="max-height: 200px;">

                    <img [src]="imagePreviewUrl" class="w-full h-full" style="object-fit: cover; display: block;" />

                    <div class="absolute top-0 right-0 p-2"
                        style="background: linear-gradient(to bottom left, rgba(0,0,0,0.4), transparent); border-bottom-left-radius: 20px;">
                        <button pButton type="button" icon="pi pi-trash" type="button"
                            class="p-button-danger p-button-rounded p-button-sm p-button-text bg-white-alpha-20 backdrop-blur-sm"
                            (click)="onClearImage()">
                        </button>
                    </div>
                </div>

                <p-fileUpload name="banner" [multiple]="false" accept="image/*"
                    [maxFileSize]="5000000" [showUploadButton]="false" [showCancelButton]="false"
                    [chooseLabel]="'grupo.botoes.selecionar_imagem' | translate" chooseIcon="pi pi-upload"
                    styleClass="p-button-outlined w-full" (onSelect)="onSelectImage($event)">
                </p-fileUpload>
                <small class="text-500 mt-2 text-center">{{'configuracao-mine-shop.texts.recomendacao_imagem' |
                    translate}}</small>
            </div>
        </div>

        <div class="surface-card p-4 border-round-xl border-1 surface-border mb-4 shadow-sm">
            <div class="flex align-items-center gap-2 mb-4">
                <i class="pi pi-link text-primary"></i>
                <span
                    class="text-900 font-bold uppercase text-xs mt-1">{{'configuracao-mine-shop.texts.links_integracoes'
                    | translate}}</span>
            </div>

            <div class="flex flex-column gap-4">
                <span class="p-float-label">
                    <input pInputText id="url" formControlName="urlDoMiniShopping" class="w-full border-round-lg p-3" />
                    <label for="url">{{'configuracao-mine-shop.texts.url_shopping' | translate}}</label>
                </span>

                <div class="p-inputgroup">
                    <span class="p-inputgroup-addon bg-white border-round-left-lg">
                        <i class="pi pi-whatsapp text-green-500"></i>
                    </span>
                    <input pInputText [placeholder]="'configuracao-mine-shop.texts.whatsapp' | translate"
                        formControlName="telefone" class="border-round-right-lg p-3" />
                </div>

                <div class="p-inputgroup">
                    <span class="p-inputgroup-addon bg-white border-round-left-lg">
                        <i class="pi pi-instagram text-pink-500"></i>
                    </span>
                    <input pInputText [placeholder]="'configuracao-mine-shop.texts.instagram' | translate"
                        formControlName="perfilInstagram" class="border-round-right-lg p-3" />
                </div>

                <div class="p-inputgroup">
                    <span class="p-inputgroup-addon bg-white border-round-left-lg">
                        <i class="pi pi-facebook text-blue-600"></i>
                    </span>
                    <input pInputText [placeholder]="'configuracao-mine-shop.texts.facebook' | translate"
                        formControlName="perfilFacebook" class="border-round-right-lg p-3" />
                </div>

            </div>
        </div>

        <div class="flex justify-content-end mt-4 py-4 gap-3">
            <p-button [label]="('configuracao-mine-shop.texts.fechar' | translate) + ' (Esc)'" (click)="closeAparenciaDialog()"
                severity="secondary" styleClass="p-button-text font-bold"></p-button>
        </div>
    </form>
</p-sidebar>

<p-sidebar [(visible)]="mostrarConfigurarPrecoECobertura" (onShow)="onSidebarShow()" position="right"
    [style]="{ width: 'min(64rem, 95vw)' }" [blockScroll]="true" styleClass="shadow-lg">

    <ng-template pTemplate="header">
        <div class="sidebar-wave-header sidebar-wave-header--info">
            <div class="sidebar-wave-header-content">
                <div class="sidebar-wave-icon-container">
                    <i class="pi pi-map" aria-hidden="true"></i>
                </div>
                <div class="sidebar-wave-header-text">
                    <h2>{{'configuracao-mine-shop.texts.configurar_cobertura_precos' | translate}}</h2>
                    <p>{{'configuracao-mine-shop.texts.gerencie_areas' | translate}}</p>
                </div>
                <!-- Indicador de autosave -->
                <div class="autosave-indicator" *ngIf="estadoSalvamentoCobertura">
                    <span *ngIf="estadoSalvamentoCobertura === 'salvando'" class="autosave-salvando">
                        <i class="pi pi-spin pi-spinner"></i>
                        {{'configuracao-mine-shop.texts.autosave_salvando' | translate}}
                    </span>
                    <span *ngIf="estadoSalvamentoCobertura === 'guardado'" class="autosave-guardado">
                        <i class="pi pi-check-circle"></i>
                        {{'configuracao-mine-shop.texts.autosave_guardado' | translate}}
                    </span>
                    <span *ngIf="estadoSalvamentoCobertura === 'erro'" class="autosave-erro">
                        <i class="pi pi-exclamation-circle"></i>
                        {{'configuracao-mine-shop.texts.autosave_erro' | translate}}
                    </span>
                </div>
            </div>
            <div class="sidebar-wave-decorative-circle circle-1" aria-hidden="true"></div>
            <div class="sidebar-wave-decorative-circle circle-2" aria-hidden="true"></div>
            <svg class="sidebar-wave-svg" viewBox="0 0 1200 40" preserveAspectRatio="none" aria-hidden="true">
                <path d="M0,20 C150,40 350,0 500,20 C650,40 850,0 1000,20 C1100,32 1150,20 1200,20 L1200,40 L0,40 Z" fill="white"/>
            </svg>
        </div>
    </ng-template>

    <form [formGroup]="formCoberturaEnvio" class="p-fluid pt-2">

        <div class="surface-card p-4 border-round-xl border-1 surface-border mb-4 shadow-sm">
            <div class="flex align-items-center gap-2 mb-4">
                <i class="pi pi-map-marker text-primary"></i>
                <span
                    class="text-900 font-bold uppercase text-xs mt-1">{{'configuracao-mine-shop.texts.origem_atendimento'
                    | translate}}</span>
            </div>

            <div class="grid flex-column gap-3">
                <div
                    class="flex align-items-center justify-content-between p-3 surface-50 border-round-lg border-1 surface-border">
                    <div class="flex align-items-center gap-3 flex-grow-1">
                        <div class="flex flex-column w-full">
                            <span
                                class="text-xs text-500 font-bold uppercase">{{'configuracao-mine-shop.texts.endereco_atual'
                                | translate}}</span>

                            <span class="text-900 font-bold mt-1">
                                {{ configuracaoEmpresaAtual?.endereco || ('configuracao-mine-shop.texts.ponto_origem_nao_definido' | translate) }}
                            </span>
                        </div>
                    </div>
                    <p-button icon="pi pi-map-marker" [text]="true"
                        [label]="'configuracao-mine-shop.texts.editar_no_mapa' | translate" size="small"
                        (onClick)="abrirModalEndereco()"></p-button>
                </div>

                <div
                    class="flex align-items-center gap-3 p-3 bg-white border-round-lg border-1 surface-border shadow-sm">
                    <div class="flex flex-column">
                        <span
                            class="text-xs text-500 font-bold uppercase">{{'configuracao-mine-shop.texts.cidade_estado_pais'
                            | translate}}</span>
                        <span class="text-700 font-medium mt-1">
                            {{ configuracaoEmpresaAtual?.cidade?.nome }}, {{
                            configuracaoEmpresaAtual?.cidade?.estado?.nome }} — {{
                            configuracaoEmpresaAtual?.cidade?.estado?.pais?.nome }}
                        </span>
                    </div>
                </div>
            </div>
        </div>

        <div class="surface-card p-4 border-round-xl border-1 surface-border mb-4 shadow-sm">
            <div class="field">
                <label class="block mb-3 font-bold text-900">{{'configuracao-mine-shop.texts.tipo_cobertura_envio' |
                    translate}}</label>
                <p-dropdown formControlName="tipoPrecoCoberturaDeEnvio" [options]="tiposDeCoberturaDeEnvioOptions"
                    optionLabel="label" optionValue="value" appendTo="body"
                    panelStyleClass="dropdown-panel-above-modal"
                    [placeholder]="'configuracao-mine-shop.texts.selecione_tipo_cobertura' | translate">
                </p-dropdown>
            </div>

            <!-- Item de Frete: exibido quando o tipo exige cobranca de frete (!= SEM_PRECO) -->
            <div *ngIf="tipoSelecionadoCobertura && tipoSelecionadoCobertura !== 'SEM_PRECO'"
                class="field mt-3 fadein animation-duration-200">
                <label class="block mb-2 font-bold text-primary">
                    {{ 'configuracao-mine-shop.texts.item_de_frete_label' | translate }}
                </label>
                <input type="text" pInputText
                    [value]="itemDeFreteDisplay"
                    readonly
                    class="w-full border-round-lg"
                    [pTooltip]="'configuracao-mine-shop.texts.item_de_frete_travado' | translate"
                    tooltipPosition="top" />

                <small class="form-hint block mt-2 text-500">
                    <i class="pi pi-info-circle mr-1"></i>
                    {{ 'configuracao-mine-shop.texts.item_de_frete_hint' | translate }}
                </small>
            </div>

            <div *ngIf="formCoberturaEnvio.get('tipoPrecoCoberturaDeEnvio')?.value === 'PRECO_FIXO'"
                class="p-4 border-round-xl border-1 surface-border bg-primary-reverse mt-3 fadein animation-duration-200">
                <div class="field m-0">
                    <label class="font-bold text-primary">{{'configuracao-mine-shop.texts.valor_taxa_fixo' |
                        translate}}</label>
                    <p-inputNumber formControlName="precoFixo" mode="decimal"
                        [prefix]="configuracaoEmpresaAtual?.moeda?.simbolo + ' '" [locale]="moedaLocal"
                        [useGrouping]="true"
                        [minFractionDigits]="casasDecimaisDaMoeda"
                        [maxFractionDigits]="casasDecimaisDaMoeda"
                        [monetaryMask]="casasDecimaisDaMoeda"
                        styleClass="w-full mt-2"
                        inputStyleClass="font-bold text-xl border-round-lg"></p-inputNumber>
                    <div class="flex align-items-center gap-2 mt-3">
                        <i class="pi pi-info-circle text-primary"></i>
                        <small class="text-700 font-medium">{{'configuracao-mine-shop.texts.info_preco_fixo' |
                            translate}}</small>
                    </div>
                </div>
            </div>

            <div *ngIf="formCoberturaEnvio.get('tipoPrecoCoberturaDeEnvio')?.value === 'SEM_PRECO'"
                class="p-4 border-round-xl border-1 border-dashed surface-border surface-50 text-center mt-3 fadein animation-duration-200">
                <i class="pi pi-info-circle text-4xl mb-3 text-400"></i>
                <p class="m-0 font-bold text-700">{{'configuracao-mine-shop.texts.info_sem_preco' | translate}}</p>
                <small class="text-500">{{'configuracao-mine-shop.texts.frete_combinar' | translate}}</small>
            </div>

            <div *ngIf="formCoberturaEnvio.get('tipoPrecoCoberturaDeEnvio')?.value === 'DISTANCIA_POR_KM'"
                class="p-4 border-round-xl border-1 surface-border bg-primary-reverse mt-3 fadein animation-duration-200">

                <div formArrayName="rangos">
                    <div *ngIf="rangos.length > 0" [formGroupName]="0">
                        <div class="grid">
                            <div class="col-12 md:col-6">
                                <label class="font-bold text-primary block mb-2">{{'configuracao-mine-shop.texts.distancia_maxima_entrega' | translate}}</label>
                                <p-inputNumber formControlName="metros" suffix=" km" [min]="1" styleClass="w-full"
                                    inputStyleClass="font-bold border-round-lg">
                                </p-inputNumber>
                            </div>

                            <div class="col-12 md:col-6">
                                <label class="font-bold text-primary block mb-2">{{'configuracao-mine-shop.texts.preco_por_km_rodado' | translate}}</label>
                                <p-inputNumber formControlName="preco" mode="decimal"
                                    [prefix]="configuracaoEmpresaAtual?.moeda?.simbolo + ' '" [locale]="moedaLocal"
                                    [useGrouping]="true"
                                    [minFractionDigits]="casasDecimaisDaMoeda"
                                    [maxFractionDigits]="casasDecimaisDaMoeda"
                                    [monetaryMask]="casasDecimaisDaMoeda"
                                    styleClass="w-full"
                                    inputStyleClass="font-bold border-round-lg">
                                </p-inputNumber>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="flex align-items-center gap-2 mt-3">
                    <i class="pi pi-info-circle text-primary"></i>
                    <small class="text-700 font-medium">{{'configuracao-mine-shop.texts.info_calculo_km' | translate}}</small>
                </div>
            </div>
        </div>

        <div class="grid"
            [style.display]="formCoberturaEnvio.get('tipoPrecoCoberturaDeEnvio')?.value === 'DISTANCIA_RAIO_METROS' ? null : 'none'">
            <div class="col-12 lg:col-7">
                <div class="relative border-round-2xl overflow-hidden shadow-3 border-1 surface-border sticky top-0"
                    style="height: 550px;">
                    <div id="map-leaflet" style="height: 100%; width: 100%;"></div>
                    <div class="absolute top-0 left-0 m-3 z-1">
                        <p-tag [value]="'configuracao-mine-shop.texts.visualizacao_raio' | translate" severity="info"
                            styleClass="px-3 py-2 border-round-pill shadow-2"></p-tag>
                    </div>
                </div>
            </div>

            <div class="col-12 lg:col-5">
                <div class="surface-card p-4 border-round-xl border-1 surface-border shadow-sm h-full">
                    <div class="flex align-items-center justify-content-between mb-4">
                        <span class="block font-bold text-900 uppercase text-xs">
                            {{ 'configuracao-mine-shop.texts.faixas_raio' | translate }}
                        </span>
                        <p-tag [value]="rangos.length + ' ' + ('configuracao-mine-shop.texts.faixas' | translate)"
                            severity="warning" styleClass="border-round-pill"></p-tag>
                    </div>

                    <div class="flex flex-column gap-3 overflow-y-auto pr-2" style="max-height: 480px;"
                        formArrayName="rangos">
                        <div *ngFor="let r of rangos.controls; let i = index" [formGroupName]="i"
                            class="flex flex-column gap-2 p-3 border-round-xl border-1 surface-border mb-2 bg-white hover:shadow-2 transition-all transition-duration-200 fadeinleft">

                            <div class="flex align-items-center justify-content-between mb-1">
                                <div class="flex align-items-center gap-2">
                                    <div class="w-1rem h-1rem border-circle shadow-1"
                                        [style.backgroundColor]="coresFaixas[i % coresFaixas.length]">
                                    </div>
                                    <span class="text-sm font-bold text-700">{{'configuracao-mine-shop.texts.faixa' |
                                        translate}} {{i + 1}}</span>
                                </div>
                                <div class="flex align-items-center gap-1">
                                    <button pButton icon="pi pi-refresh" type="button"
                                        class="faixa-btn-refresh p-button-rounded p-button-text p-button-sm"
                                        (click)="updateMapCircles()"
                                        [pTooltip]="'configuracao-mine-shop.texts.recarregar_faixa' | translate"
                                        tooltipPosition="top">
                                    </button>
                                    <button pButton type="button" icon="pi pi-trash"
                                        class="faixa-btn-delete p-button-rounded p-button-text p-button-sm"
                                        (click)="removerRango(i)"
                                        [pTooltip]="'configuracao-mine-shop.texts.remover_faixa' | translate"
                                        tooltipPosition="top">
                                    </button>
                                </div>
                            </div>

                            <div class="grid mt-1 faixa-inputs-wrapper">
                                <div class="col-6">
                                    <label
                                        class="text-xs font-bold text-500 uppercase">{{'configuracao-mine-shop.texts.limite_max'
                                        | translate}} (m)</label>
                                    <p-inputNumber formControlName="metros" styleClass="w-full mt-1"
                                        inputStyleClass="w-full border-round-lg text-center font-bold"
                                        suffix=" m"></p-inputNumber>
                                </div>
                                <div class="col-6">
                                    <label
                                        class="text-xs font-bold text-500 uppercase">{{'configuracao-mine-shop.texts.preco'
                                        | translate}}</label>
                                    <p-inputNumber formControlName="preco" mode="decimal"
                                        [prefix]="configuracaoEmpresaAtual?.moeda?.simbolo + ' '" [locale]="moedaLocal"
                                        [useGrouping]="true"
                                        [minFractionDigits]="casasDecimaisDaMoeda"
                                        [maxFractionDigits]="casasDecimaisDaMoeda"
                                        [monetaryMask]="casasDecimaisDaMoeda"
                                        styleClass="w-full mt-1"
                                        inputStyleClass="w-full border-round-lg text-center font-bold text-primary">
                                    </p-inputNumber>
                                </div>
                            </div>
                        </div>
                    </div>

                    <p-button [label]="'configuracao-mine-shop.texts.adicionar_faixa' | translate" icon="pi pi-plus"
                        [outlined]="true" styleClass="w-full border-dashed border-round-xl mt-3 py-3 font-bold"
                        (click)="adicionarRango()"></p-button>
                </div>
            </div>
        </div>

        <div class="flex justify-content-end mt-6 pt-4 border-top-1 surface-border gap-3">
            <p-button [label]="('configuracao-mine-shop.texts.fechar' | translate) + ' (Esc)'"
                (click)="closePrecoECoberturaDialog()" severity="secondary"
                styleClass="p-button-text font-bold"></p-button>
        </div>
    </form>
</p-sidebar>

<!-- Modal Confirmacao Restaurar Horarios Padrao -->
<p-dialog
    [(visible)]="mostrarConfirmarResetHorarios"
    [showHeader]="false"
    [modal]="true"
    [closable]="false"
    [draggable]="false"
    appendTo="body"
    maskStyleClass="reset-confirm-mask"
    styleClass="dialog-wave-redesign"
    [style]="{ width: '480px', height: 'auto' }">

    <div class="dialog-wave-header dialog-wave-header--info">
        <div class="dialog-wave-header-content">
            <div class="dialog-wave-icon-container">
                <i class="pi pi-clock" aria-hidden="true"></i>
            </div>
            <div class="dialog-wave-header-text">
                <h2>{{'configuracao-mine-shop.texts.restaurar_horarios_titulo' | translate}}</h2>
                <p>{{'configuracao-mine-shop.texts.restaurar_horarios_subtitulo' | translate}}</p>
            </div>
        </div>
        <div class="dialog-wave-decorative-circle circle-1" aria-hidden="true"></div>
        <div class="dialog-wave-decorative-circle circle-2" aria-hidden="true"></div>
        <svg class="dialog-wave-svg" viewBox="0 0 1200 40" preserveAspectRatio="none" aria-hidden="true">
            <path d="M0,20 C150,40 350,0 500,20 C650,40 850,0 1000,20 C1100,32 1150,20 1200,20 L1200,40 L0,40 Z" fill="white"/>
        </svg>
    </div>

    <div class="dialog-wave-body">
        <p class="text-700 line-height-3 m-0">{{'configuracao-mine-shop.texts.restaurar_horarios_mensagem' | translate}}</p>
    </div>

    <ng-template pTemplate="footer">
        <div class="reset-cores-footer-buttons">
            <button pButton class="p-button-secondary p-button-text font-bold"
                (click)="fecharConfirmarResetHorarios()">
                {{'configuracao-mine-shop.texts.cancelar' | translate}}
            </button>
            <button pButton class="p-button-primary font-bold"
                icon="pi pi-refresh"
                (click)="confirmarResetHorarios()">
                {{'configuracao-mine-shop.texts.restaurar_horarios_confirmar' | translate}}
            </button>
        </div>
    </ng-template>
</p-dialog>

<!-- Modal Confirmacao Restaurar Cores Padrao -->
<p-dialog
    [(visible)]="mostrarConfirmarResetCores"
    [showHeader]="false"
    [modal]="true"
    [closable]="false"
    [draggable]="false"
    appendTo="body"
    maskStyleClass="reset-confirm-mask"
    styleClass="dialog-wave-redesign"
    [style]="{ width: '480px', height: 'auto' }">

    <div class="dialog-wave-header dialog-wave-header--info">
        <div class="dialog-wave-header-content">
            <div class="dialog-wave-icon-container">
                <i class="pi pi-refresh" aria-hidden="true"></i>
            </div>
            <div class="dialog-wave-header-text">
                <h2>{{'configuracao-mine-shop.texts.restaurar_cores_titulo' | translate}}</h2>
                <p>{{'configuracao-mine-shop.texts.restaurar_cores_subtitulo' | translate}}</p>
            </div>
        </div>
        <div class="dialog-wave-decorative-circle circle-1" aria-hidden="true"></div>
        <div class="dialog-wave-decorative-circle circle-2" aria-hidden="true"></div>
        <svg class="dialog-wave-svg" viewBox="0 0 1200 40" preserveAspectRatio="none" aria-hidden="true">
            <path d="M0,20 C150,40 350,0 500,20 C650,40 850,0 1000,20 C1100,32 1150,20 1200,20 L1200,40 L0,40 Z" fill="white"/>
        </svg>
    </div>

    <div class="dialog-wave-body">
        <p class="text-700 line-height-3 m-0">{{'configuracao-mine-shop.texts.restaurar_cores_mensagem' | translate}}</p>
    </div>

    <ng-template pTemplate="footer">
        <div class="reset-cores-footer-buttons">
            <button pButton class="p-button-secondary p-button-text font-bold"
                (click)="fecharConfirmarResetCores()">
                {{'configuracao-mine-shop.texts.cancelar' | translate}}
            </button>
            <button pButton class="p-button-primary font-bold"
                icon="pi pi-refresh"
                (click)="confirmarResetCores()">
                {{'configuracao-mine-shop.texts.restaurar_cores_confirmar' | translate}}
            </button>
        </div>
    </ng-template>
</p-dialog>

<!-- ======================== MODAL DE ENDERECO COM MAPA ======================== -->
<p-dialog
    [(visible)]="mostrarModalEndereco"
    [modal]="true"
    [closable]="true"
    [showHeader]="false"
    appendTo="body"
    [baseZIndex]="11000"
    [style]="{ width: 'min(440px, 94vw)', borderRadius: '16px' }"
    [contentStyle]="{ padding: '0', borderRadius: '16px' }"
    styleClass="endereco-mapa-dialog"
    maskStyleClass="endereco-mapa-dialog-mask"
    (onShow)="onModalEnderecoShow()"
    (onHide)="fecharModalEndereco()">

    <div class="endereco-modal-content">
        <div class="endereco-modal-header">
            <button class="endereco-modal-back-btn" type="button" (click)="fecharModalEndereco()">
                <i class="pi pi-arrow-left"></i>
            </button>
            <h3 class="endereco-modal-titulo">
                {{'configuracao-mine-shop.texts.endereco_titulo_modal' | translate}}
            </h3>
        </div>

        <!-- Botao "Usar minha localizacao" -->
        <button class="endereco-btn-localizacao"
                type="button"
                [disabled]="carregandoLocalizacao"
                (click)="onUsarMinhaLocalizacao()">
            <i class="pi" [ngClass]="carregandoLocalizacao ? 'pi-spin pi-spinner' : 'pi-map-marker'"></i>
            <span *ngIf="!carregandoLocalizacao">{{'configuracao-mine-shop.texts.endereco_usar_localizacao' | translate}}</span>
            <span *ngIf="carregandoLocalizacao">{{'configuracao-mine-shop.texts.endereco_carregando_localizacao' | translate}}</span>
        </button>

        <!-- Dica de ajuste do pin -->
        <div class="endereco-mapa-dica">
            {{'configuracao-mine-shop.texts.endereco_ajuste_pin' | translate}}
        </div>

        <!-- Mapa Leaflet -->
        <div class="endereco-mapa-container">
            <div id="map-endereco-modal" style="width: 100%; height: 100%;"></div>
        </div>

        <!-- Mensagem de erro de geolocalizacao -->
        <div class="endereco-mapa-erro" *ngIf="erroGeolocalizacao">
            {{ erroGeolocalizacao | translate }}
        </div>

        <!-- Campo Rua/Avenida -->
        <div class="endereco-campo">
            <label class="endereco-campo-label">{{'configuracao-mine-shop.texts.endereco_rua' | translate}} *</label>
            <div class="endereco-campo-input-wrap">
                <i class="pi pi-map-marker endereco-campo-icon"></i>
                <input type="text" pInputText [(ngModel)]="enderecoRua" [ngModelOptions]="{standalone: true}"
                    [placeholder]="'configuracao-mine-shop.texts.placeholder_endereco' | translate"
                    class="endereco-campo-input" />
            </div>
        </div>

        <!-- Campo Numero (opcional) -->
        <div class="endereco-campo">
            <label class="endereco-campo-label">
                {{'configuracao-mine-shop.texts.endereco_numero' | translate}}
                <span class="endereco-campo-opcional">{{'configuracao-mine-shop.texts.endereco_numero_opcional' | translate}}</span>
            </label>
            <div class="endereco-campo-input-wrap">
                <input type="text" pInputText [(ngModel)]="enderecoNumero" [ngModelOptions]="{standalone: true}"
                    [placeholder]="'configuracao-mine-shop.texts.placeholder_endereco' | translate"
                    class="endereco-campo-input" />
            </div>
        </div>

        <!-- Campo Complemento (opcional) -->
        <div class="endereco-campo">
            <label class="endereco-campo-label">
                {{'configuracao-mine-shop.texts.endereco_complemento' | translate}}
                <span class="endereco-campo-opcional">{{'configuracao-mine-shop.texts.endereco_complemento_opcional' | translate}}</span>
            </label>
            <div class="endereco-campo-input-wrap">
                <input type="text" pInputText [(ngModel)]="enderecoComplemento" [ngModelOptions]="{standalone: true}"
                    [placeholder]="'configuracao-mine-shop.texts.placeholder_endereco' | translate"
                    class="endereco-campo-input" />
            </div>
        </div>

        <!-- Campo Referencia (opcional) -->
        <div class="endereco-campo">
            <label class="endereco-campo-label">
                {{'configuracao-mine-shop.texts.endereco_referencia' | translate}}
                <span class="endereco-campo-opcional">{{'configuracao-mine-shop.texts.endereco_referencia_opcional' | translate}}</span>
            </label>
            <div class="endereco-campo-input-wrap">
                <input type="text" pInputText [(ngModel)]="enderecoReferencia" [ngModelOptions]="{standalone: true}"
                    [placeholder]="'configuracao-mine-shop.texts.placeholder_endereco' | translate"
                    class="endereco-campo-input" />
            </div>
        </div>

        <!-- Botao Confirmar Endereco -->
        <button class="endereco-btn-confirmar"
                [disabled]="!enderecoFormValido"
                (click)="confirmarEndereco()">
            {{'configuracao-mine-shop.texts.endereco_confirmar' | translate}}
        </button>
    </div>
</p-dialog>

<!--
    Diálogo para solicitar o Nome da loja ao habilitar o Mini Shopping
    sem URL configurada. O usuário digita um NOME amigável (ex: "Mi Tienda")
    e o frontend converte silenciosamente para o slug (ex: "mi-tienda")
    enviado ao backend no campo `urlDoMiniShopping`. Contrato preservado.
-->
<p-dialog
    [(visible)]="mostrarDialogUrl"
    [showHeader]="false"
    [modal]="true"
    [closable]="false"
    [draggable]="false"
    styleClass="dialog-wave-redesign"
    [style]="{ width: '480px', height: 'auto' }"
    (onHide)="onCancelarDialogUrl()">

    <div class="dialog-wave-header dialog-wave-header--info">
        <div class="dialog-wave-header-content">
            <div class="dialog-wave-icon-container">
                <i class="pi pi-shop" aria-hidden="true"></i>
            </div>
            <div class="dialog-wave-header-text">
                <h2>{{'configuracao-mine-shop.texts.nome_loja_dialog_titulo' | translate}}</h2>
                <p>{{'configuracao-mine-shop.texts.nome_loja_dialog_descricao' | translate}}</p>
            </div>
        </div>
        <div class="dialog-wave-decorative-circle circle-1" aria-hidden="true"></div>
        <div class="dialog-wave-decorative-circle circle-2" aria-hidden="true"></div>
        <svg class="dialog-wave-svg" viewBox="0 0 1200 40" preserveAspectRatio="none" aria-hidden="true">
            <path d="M0,20 C150,40 350,0 500,20 C650,40 850,0 1000,20 C1100,32 1150,20 1200,20 L1200,40 L0,40 Z" fill="white"/>
        </svg>
    </div>

    <div class="flex flex-column gap-3 p-3">
        <span class="p-float-label mt-3">
            <input pInputText id="nomeLojaHabilitar" [(ngModel)]="nomeLojaParaHabilitar"
                   class="w-full border-round-lg p-3"
                   [maxlength]="slugMaxChars"
                   (keydown.enter)="onConfirmarUrlEHabilitar()" />
            <label for="nomeLojaHabilitar">{{ 'configuracao-mine-shop.texts.nome_loja_label' | translate }}</label>
        </span>

        <!-- Exemplo estático de como o nome vira URL (ajuda o usuário leigo a entender) -->
        <small class="text-500">
            {{ 'configuracao-mine-shop.texts.nome_loja_dialog_exemplo' | translate }}
        </small>

        <!-- Preview em tempo real do slug derivado (transparência para o usuário) -->
        <div *ngIf="slugLoja" class="flex align-items-center gap-2 p-2 border-round-lg surface-100">
            <i class="pi pi-link text-primary"></i>
            <small class="text-700">
                {{ 'configuracao-mine-shop.texts.nome_loja_dialog_preview' | translate }}
                <span class="font-bold text-primary">/menu/{{ slugLoja }}</span>
            </small>
        </div>
    </div>

    <div class="flex justify-content-end gap-2 p-3 pt-0">
        <button pButton
                [label]="'configuracao-mine-shop.texts.cancelar' | translate"
                class="p-button-text"
                (click)="onCancelarDialogUrl()">
        </button>
        <button pButton
                [label]="'configuracao-mine-shop.texts.url_dialog_confirmar' | translate"
                icon="pi pi-check"
                [loading]="salvandoUrl"
                [disabled]="!slugLojaValido"
                (click)="onConfirmarUrlEHabilitar()">
        </button>
    </div>
</p-dialog>